const translations = { needHelp: 'Need help?', talkToBtime: 'Talk to Btime' }

export default translations
